var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"userinfoshow"},[_c('user-title',{attrs:{"msg":_vm.msg}}),_vm._v(" "),_c('user-index-collection-info',{ref:"goodslist",attrs:{"itemright":_vm.itemright,"pagesize":20,"description":_vm.description,"emptyimg":_vm.emptyimg},on:{"editgoods":_vm.editgoods}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cdde82d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserCollection.vue
// module id = null
// module chunks = 